import "./FlashStyle.css";
import TitleOfSection from "../TitleOfSection";
import ImageSide from "../Images/ImageSide.png";
import RightIcon from "../Images/Arrow_right.svg";
import Card from "../../Card";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import { Keyboard, Pagination, Navigation } from "swiper/modules";
import { useEffect, useState } from "react";
import { getFlashsale } from "../../../network/api/product.js";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { link } from "../../../config.js";
import { useTranslation } from "react-i18next";

const FlashStyle = ({ id, subCategory, update_p, personal, flashSell }) => {
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const navigate = useNavigate();

  const getProducts = async () => {
   
    try {
      const { data } = await axios.get(`${link}product/`);
      setProducts(data);
      const filteredByCategory = data.filter((product) => {
        // Check if the product belongs to the specified category or subCategory
        return (
          (id && product.category?._id === id) // Filter by subCategory ID
        );
      });

      

      // فلترة المنتجات التي تحتوي على flashDiscount أكبر من 1
      const filteredFlashDiscountProducts = filteredByCategory.filter((product) =>
        product.flashDiscount.some(
          (discount) => discount.status && discount.discount > 1
        )
      );

      // إذا وجدنا منتجات تحتوي على flashDiscount أكبر من 1
      if (filteredFlashDiscountProducts.length > 0) {
        // عرض المنتجات التي تحتوي على flashDiscount أكبر من 1 وترتيبها حسب الخصم
        const filtered = filteredFlashDiscountProducts.sort((a, b) => {
          // الحصول على أكبر خصم من flashDiscount
          const discountA = a.flashDiscount.find(
            (discount) => discount.status && discount.discount > 1
          ).discount;
          const discountB = b.flashDiscount.find(
            (discount) => discount.status && discount.discount > 1
          ).discount;
          return discountB - discountA;
        });

        setFilteredProducts(filtered);
      } else {
        // إذا لم توجد منتجات تحتوي على flashDiscount أكبر من 1، نعرض المنتجات حسب الخصم العادي
        const filtered = data
          .filter((product) => product.discount > 0) // فلترة المنتجات التي تحتوي على discount
          .sort((a, b) => b.discount - a.discount); // ترتيبها حسب الخصم من الأكبر إلى الأصغر

        setFilteredProducts(filtered);
      }
    } catch (error) {
      console.error("Error fetching featured items:", error);
    }
  };

  useEffect(() => {
    // getProductsDistinctiveItems(id).then((results) => {
    //   setProducts(results?.data);
    // });
    getProducts();
  }, [id]);
  // useEffect(() => {
  //   getFlashsale(id).then((results) => {
  //     setProducts(results?.data);
  //   });
  // }, [id]);
  return (
    filteredProducts.length > 0 && (
      <div className="my-5 ">
        <div className="container mb-2">
          <div className="d-flex justify-content-between align-items-center">
            <TitleOfSection title={t("flashSale")} />
            <div
              onClick={() => navigate(`/flashsale/${id}/1`)}
              className=""
              style={{ cursor: "pointer" }}
            ></div>
          </div>
        </div>
        <div className="d-none d-lg-flex justify-content-between side-products">
          <Swiper
            slidesPerView={3}
            spaceBetween={10}
            breakpoints={{
              992: {
                slidesPerView: 2,
                spaceBetween: 25,
              },
              1024: {
                slidesPerView: 2.4,
                spaceBetween: 20,
              },
              1300: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1440: {
                slidesPerView: 3.4,
                spaceBetween: 30,
              },
              1600: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
            }}
            navigation={true}
            modules={[Keyboard, Pagination, Navigation]}
            className="mySwiper mx-2 p-4"
            style={{ width: "70%" }}
          >
            {filteredProducts
              .filter((p) => p.view) // Filter products that are visible
              .reduce((acc, product, index) => {
                if (index % 2 === 0) {
                  // Create pairs of products
                  acc.push(filteredProducts.slice(index, index + 2));
                }
                return acc;
              }, [])
              .map((productPair, index) => (
                <SwiperSlide key={index} className="product-slide">
                  <div className="product-column">
                    {productPair.map((product, subIndex) => (
                      <Card
                        key={subIndex}
                        ImageCard={product?.images[0]?.secure_url}
                        personal={personal}
                        update_p={update_p}
                        brand={product.brand}
                        name={product.name}
                        price={product.price_after}
                        id={product._id}
                        rate={product.averageRating ? product.averageRating : 0}
                        price_after={product.price_after}
                        price_before={product.price_before}
                        product={product}
                      />
                    ))}
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
          <img
            src={flashSell?.images[0]?.secure_url}
            alt={flashSell?.images[0]?.public_id}
          />
        </div>

        <div className="d-lg-none" style={{ direction: "rtl" }}>
          <Swiper
            slidesPerView={1.5}
            spaceBetween={10}
            breakpoints={{
              500: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              640: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              880: {
                slidesPerView: 3.2,
                spaceBetween: 20,
              },
            }}
            navigation={true}
            modules={[Keyboard, Pagination, Navigation]}
            className="mySwiper mx-1"
          >
            {filteredProducts
              ?.filter((p) => p.view)
              .map((product, index) => (
                <SwiperSlide
                  key={index}
                  className="d-flex flex-column justify-content-center gap-3"
                >
                  <Card
                    ImageCard={product.images[0].secure_url}
                    personal={personal}
                    update_p={update_p}
                    brand={product.brand}
                    name={product.name}
                    price={product.price_after}
                    id={product._id}
                    rate={product.averageRating ? product.averageRating : 0}
                    price_after={product.price_after}
                    price_before={product.price_before}
                    product={product}
                  />
                </SwiperSlide>
              ))}
          </Swiper>
        </div>

        <div className="my-5" style={{ direction: "rtl" }}>
          <Swiper
            slidesPerView={1.5}
            spaceBetween={10}
            breakpoints={{
              500: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              640: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              880: {
                slidesPerView: 5,
                spaceBetween: 5,
              },
            }}
            navigation={true}
            modules={[Keyboard, Pagination, Navigation]}
            className="mySwiper mx-1"
          >
            {products
              ?.filter((p) => p.view && p.category && p.category._id === id)
              .map((product, index) => (
                <SwiperSlide
                  key={index}
                  className="d-flex flex-column justify-content-center"
                >
                  <Card
                    ImageCard={product.images[0].secure_url}
                    personal={personal}
                    update_p={update_p}
                    brand={product.brand}
                    name={product.name}
                    price={product.price_after}
                    id={product._id}
                    rate={product.averageRating ? product.averageRating : 0}
                    price_after={product.price_after}
                    price_before={product.price_before}
                    product={product}
                  />
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      </div>
    )
  );
};
export default FlashStyle;
